import React from "react";
import { Link as RouterLink } from "react-router-dom";
import "./NekrologTeaser.scss";

const POINTS = [
  "Jakie informacje musi zawierać poprawny nekrolog",
  "Jak sformułować tekst ceremonii i danych Zmarłego",
  "Jak uniknąć błędów, które mogą sprawić że bliscy nie dotrą na pogrzeb",
  "Jak wygenerować gotowy nekrolog do druku w kilka minut",
];

export default function NekrologTeaser() {
  return (
    <section className="nteaser">
      <div className="nteaser__inner">
        <div className="nteaser__text">
          <span className="nteaser__label">Poradnik</span>
          <h2 className="nteaser__title">
            Co to jest nekrolog i jak napisać poprawną klepsydrę?
          </h2>
          <p className="nteaser__lead">
            Nekrolog to oficjalny komunikat o śmierci i uroczystościach
            pogrzebowych. Przygotowanie go w trudnym czasie żałoby bywa
            stresujące - dlatego zebraliśmy wszystko, co musisz wiedzieć w
            jednym miejscu.
          </p>
          <ul className="nteaser__list">
            {POINTS.map((p, i) => (
              <li key={i} className="nteaser__list-item">
                <span className="nteaser__check" />
                {p}
              </li>
            ))}
          </ul>
          <RouterLink to="/co-to-nekrolog" className="nteaser__btn">
            Czytaj poradnik
          </RouterLink>
        </div>
        <div className="nteaser__visual" aria-hidden="true">
          <div className="nteaser__card">
            <div className="nteaser__card-cross" />
            <div className="nteaser__card-line nteaser__card-line--name" />
            <div className="nteaser__card-line nteaser__card-line--short" />
            <div className="nteaser__card-line" />
            <div className="nteaser__card-line nteaser__card-line--short" />
            <div className="nteaser__card-line" />
            <div className="nteaser__card-line nteaser__card-line--short" />
          </div>
        </div>
      </div>
    </section>
  );
}
